import apiService from "./api";

const employeeService = {
  addMultipleUsers(companyId, payload) {
    return apiService.post(
      `/companies/${companyId}/add-multiple-users`,
      payload
    );
  },
  // Group-add for delivery companies — writes to delivery_company_user and only
  // accepts `dostava` / `admin_delivery`. Response mirrors addMultipleUsers and
  // adds an `invalid_type_users` bucket (see 09_09_2026 backend answer, point 1).
  addMultipleUsersDelivery(companyId, payload) {
    return apiService.post(
      `/companies/${companyId}/add-multiple-users-delivery`,
      payload
    );
  },
  getParentCompanies(companyId) {
    return apiService.get(`/companies/${companyId}/parent-companies`);
  },
  setTimeLimit(item) {
    return apiService.post("/user/change-user-time-limit", item);
  },
  setCanReport(data) {
    return apiService.post("/user/can-see-company-reports", data);
  },
  getCompanies() {
    return apiService.get("/companies");
  },
  getUsers(route) {
    return apiService.get(route);
  },
  deleteUser(userId) {
    return apiService.delete(`/user/${userId}`);
  },
  getCompanyUsers(companyId) {
    return apiService.get(`/companies/${companyId}/users`);
  },
  getCompanyUsersDelivery(companyId) {
    return apiService.get(`/companies/${companyId}/users-delivery`);
  },
  getRestaurantUsers(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users`);
  },
  getRestaurantUsersDelivery(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users-delivery`);
  },
  // Update user (employee)
  updateUser(userId, userData) {
    return apiService.patch(`/user/${userId}`, userData);
  },
  // Update a delivery-company user. Separate from PATCH /user/:id (which touches
  // the company_id / companies() relation that does not apply to delivery).
  // Body fields are all optional; `type` must stay `dostava` / `admin_delivery`
  // (422 otherwise). `email` was removed from this endpoint (11_09_2026 backend
  // answer, pt 4) — the FE form correctly never sends it. The endpoint now also
  // accepts pivot fields (contact_phone, bank_account, paying_type, paying,
  // note); no form UI for these yet — see 11_09_2026 questions doc.
  updateUserDelivery(companyId, userId, userData) {
    return apiService.patch(
      `/companies/${companyId}/users-delivery/${userId}`,
      userData
    );
  },
  // "Delete" a delivery-company user — backend sets active = 0 on the
  // delivery_company_user pivot, it does not remove the row
  // (see 09_09_2026 backend answer, point 4).
  deleteUserDelivery(companyId, userId) {
    return apiService.delete(`/companies/${companyId}/users-delivery/${userId}`);
  },
  // Create user based on route (company or restaurant)
  createCompanyUser(companyId, userData, isDelivery = false) {
    const endpoint = isDelivery ? "users-delivery" : "users";
    return apiService.post(`/companies/${companyId}/${endpoint}`, userData);
  },
  createRestaurantUser(restaurantId, userData, isDelivery = false) {
    const endpoint = isDelivery ? "users-delivery" : "users";
    return apiService.post(`/restaurants/${restaurantId}/${endpoint}`, userData);
  },
  // Upload user photo
  uploadUserPhoto(formData) {
    return apiService.post("/user/photo", formData);
  },
  // Change user company
  changeUserCompany(userData) {
    return apiService.post("/companies/change-user-company", userData);
  },
};

export default employeeService;
